import { HTTPRequestMethods } from "../../Shared/httpRequestMethods";
import { convertObjectKeysToSnakeCase } from "../../Shared/ConvertObjectKeysToSnakeCase";
import { parseJsonResponse } from "../../Shared/parseJsonResponse";

export const createUserInvitationRequest = ({ onResponse, onError, body }) => {
  fetch(
    "/api/user_invitation_requests",
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};
